export default event => {
  console.log('[OrderPriceRecalculated] Got orders.price.recalculated event.', event)
}
